import React from 'react';
import { TRACKS } from '../data/curriculum';

const S = {
  page: { maxWidth:680, margin:'0 auto', padding:'32px 20px 80px' },
  header: { textAlign:'center', marginBottom:28 },
  levelBadge: (color) => ({ display:'inline-block', fontSize:13, fontWeight:700, color, background:color+'15', border:`1px solid ${color}44`, padding:'4px 14px', borderRadius:20, marginBottom:10, letterSpacing:'0.08em' }),
  title: { fontSize:32, fontWeight:800, color:'#f8fafc', letterSpacing:'-0.02em', margin:0 },
  statsGrid: { display:'grid', gridTemplateColumns:'1fr 1fr', gap:12, marginBottom:28 },
  statCard: { background:'#0f172a', border:'1px solid #1e293b', borderRadius:16, padding:'20px', textAlign:'center' },
  statIcon: { fontSize:24, marginBottom:8 },
  statNum: (color) => ({ fontSize:28, fontWeight:800, color }),
  statLabel: { fontSize:12, color:'#475569', marginTop:4 },
  sectionLabel: { fontSize:11, fontWeight:700, letterSpacing:'0.18em', color:'#475569', marginBottom:16 },
  xpCard: { background:'#0f172a', border:'1px solid #1e293b', borderRadius:16, padding:'18px 20px', marginBottom:28 },
  xpInfo: { display:'flex', justifyContent:'space-between', fontSize:13, fontWeight:600, color:'#94a3b8', marginBottom:10 },
  xpBar: { height:8, background:'#1e293b', borderRadius:99, overflow:'hidden' },
  xpFill: (pct) => ({ height:'100%', width:`${pct}%`, background:'linear-gradient(90deg,#0ea5e9,#6366f1)', borderRadius:99, transition:'width 0.8s' }),
  trackList: { display:'flex', flexDirection:'column', gap:10 },
  trackRow: (done, color, colorDim, colorBorder) => ({ display:'flex', alignItems:'center', gap:14, background: done ? colorDim : '#0a0e18', border:`1px solid ${done ? colorBorder : '#1e293b'}`, borderRadius:12, padding:'14px 16px' }),
  trackInfo: { flex:1 },
  trackName: (done, color) => ({ fontWeight:700, fontSize:14, color: done ? color : '#475569' }),
  trackMeta: { fontSize:11, color:'#475569', marginTop:2 },
  trackStatus: (done) => ({ fontSize:11, fontWeight:700, color: done ? '#22c55e' : '#334155', background: done ? 'rgba(34,197,94,0.1)' : 'transparent', border: done ? '1px solid rgba(34,197,94,0.2)' : 'none', padding: done ? '2px 8px' : '0', borderRadius:20 }),
  progressRow: { display:'flex', alignItems:'center', gap:6 },
  miniBar: { width:50, height:3, background:'#1e293b', borderRadius:99, overflow:'hidden' },
  miniFill: (pct, color) => ({ height:'100%', width:`${pct}%`, background:color, borderRadius:99, transition:'width 0.6s' }),
};

export default function Progress({ progress, getLevel, onBack }) {
  const level = getLevel();
  const totalLessons = TRACKS.reduce((a, t) => a + t.lessons.length, 0);
  const xpToNext = level.next - progress.xp;
  const xpPct = Math.min(100, Math.round((progress.xp / level.next) * 100));

  return (
    <div style={S.page}>
      <div style={{ display:'flex', alignItems:'center', padding:'12px 20px', borderBottom:'1px solid #1e293b', background:'rgba(8,12,20,0.95)', position:'sticky', top:0, zIndex:10 }}>
        <button onClick={onBack} style={{ background:'none', border:'none', color:'#64748b', fontSize:14, cursor:'pointer', fontWeight:600, padding:0, marginRight:'auto' }}>← Back</button>
      </div>
      <div style={S.header}>
        <div style={S.levelBadge('#38bdf8')}>{level.emoji} {level.name}</div>
        <div style={S.title}>Your Journey</div>
      </div>

      <div style={S.statsGrid}>
        {[
          { icon:'⚡', n: progress.xp, label:'Total XP', color:'#38bdf8' },
          { icon:'📚', n: progress.completedLessons.length, label:'Lessons Done', color:'#4ade80' },
          { icon:'🔥', n: progress.streak, label:'Day Streak', color:'#fb923c' },
          { icon:'🏅', n: Math.floor(progress.xp / 100), label:'Badges Earned', color:'#c084fc' },
        ].map(s => (
          <div key={s.label} style={S.statCard}>
            <div style={S.statIcon}>{s.icon}</div>
            <div style={S.statNum(s.color)}>{s.n}</div>
            <div style={S.statLabel}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={S.sectionLabel}>LEVEL PROGRESS</div>
      <div style={S.xpCard}>
        <div style={S.xpInfo}>
          <span>{level.emoji} {level.name}</span>
          <span style={{ color:'#38bdf8' }}>{xpToNext > 0 ? `${xpToNext} XP to ${level.nextName}` : 'Max level!'}</span>
        </div>
        <div style={S.xpBar}><div style={S.xpFill(xpPct)} /></div>
      </div>

      <div style={S.sectionLabel}>TRACK PROGRESS</div>
      <div style={S.trackList}>
        {TRACKS.map(track => {
          const done = track.lessons.filter(l => progress.completedLessons.includes(l.id)).length;
          const pct = Math.round((done / track.lessons.length) * 100);
          const allDone = done === track.lessons.length;
          return (
            <div key={track.id} style={S.trackRow(allDone, track.color, track.colorDim, track.colorBorder)}>
              <span style={{ fontSize:22 }}>{track.emoji}</span>
              <div style={S.trackInfo}>
                <div style={S.trackName(allDone, track.color)}>{track.title}</div>
                <div style={S.trackMeta}>{done}/{track.lessons.length} lessons · {track.outcome}</div>
              </div>
              <div style={S.progressRow}>
                <div style={S.miniBar}><div style={S.miniFill(pct, track.color)} /></div>
                <span style={S.trackStatus(allDone)}>{allDone ? '✓ Done' : `${pct}%`}</span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
